<template>
  <div
    v-if="state"
    :class="{
      'py-sm px-md mt-lg rounded-sm border-1 border-gray-400': productType !== 'part'
    }"
  >
    <Variation
      :class="{
        'flex-col gap-md': true,
        'py-md': productType !== 'part'
      }"
      v-if="singleResult"
      :item="singleResult"
      :hideImage="true"
      :stack="true"
      :track-view="true"
      :show-download-model-spec="false"
      :show-where-to-buy="false"
      :show-channel-advisor="productType !== 'part'"
      :show-number-input="true"
      :show-price-info="true"
      :show-prop65-warning="true"
      :should-display-subscription-input="true"
    />
    <div v-else class="flex py-md">
      <div
        class="flex-1 flex-col md:flex-row md:items-center md:justify-between"
        v-if="hasAppliedFilters"
      >
        <h3 class="text-lg md:text-xl fw-strong m-0">
          {{ resultsLength }} {{ 'Matching Variations' | t }}
        </h3>
        <div class="flex mt-sm md:mt-0" v-stack-x:sm>
          <SloButton style="height: 48px" href="#variations">
            <span>{{ 'View' | t }}</span>
            <SloIcon name="ArrowDown" />
          </SloButton>
        </div>
      </div>
      <div v-else class="flex-1 flex-col md:flex-row md:items-center md:justify-between">
        <h3 class="text-lg md:text-xl fw-strong m-0">{{ 'General Model' | t }}</h3>
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
import {createWidgetMixin} from 'vue-instantsearch';
import {connectHits} from 'instantsearch.js/es/connectors';
import t from '../../main/i18n';
import {hasAppliedFilters} from '../utils';
import Variation from './Variation.vue';
import SloButton from '../../../lib/components/SloButton.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  name: 'ProductResult',
  mixins: [createWidgetMixin({connector: connectHits})],
  components: {
    Variation,
    SloButton,
    SloIcon
  },
  filters: {
    t
  },
  props: {
    productType: {type: String, required: true}
  },
  computed: {
    singleResult() {
      return this.resultsLength === 1 ? this.state.hits[0] : null;
    },
    resultsLength() {
      return this.state.results.nbHits;
    },
    hasAppliedFilters() {
      return hasAppliedFilters(this.state.results._state);
    }
  }
};
</script>
